import { useQuery } from '@apollo/client'

import { GetTenantConfigDocument } from '@app/graphql'

interface SubscriptionsFlag {
  loading: boolean
  enabled: boolean
}

/**
 * Reads the `subscriptions` flag from the `feature_flags` table for the current tenant.
 * Enabled by default — a tenant opts out with a row where enabled = false.
 */
export function useSubscriptionsFlag(): SubscriptionsFlag {
  const { data, loading } = useQuery(GetTenantConfigDocument, { fetchPolicy: 'cache-first' })

  const flag = data?.tenantConfig?.featureFlags?.find(f => f.key === 'subscriptions')

  return {
    loading: loading && !data,
    enabled: flag?.enabled ?? true,
  }
}

/**
 * Returns whether subscriptions (subscribe card, subscription menu items, VIP-only toggle)
 * are available for the current tenant.
 * Hidden while the tenant config is loading so opted-out tenants never see a flash of it.
 */
export function useSubscriptionsEnabled(): boolean {
  const { loading, enabled } = useSubscriptionsFlag()

  return !loading && enabled
}
